export const FIND_FILE_REFERENCE_FAILURE = 'FIND_FILE_REFERENCE_FAILURE';

export const findFileReferenceFailure = (payload: Error) => ({
    type: FIND_FILE_REFERENCE_FAILURE,
    payload,
    error: true,
});
